import { Backdrop, CircularProgress, Dialog, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";

const ListTableHeader = styled(TableCell)(
    ({ theme }) => ({
        fontSize: 15,
        fontWeight: 700,
        fontFamily: "inter",
        whiteSpace: "nowrap",
    })
);

const ListTableBody = styled(TableCell)(
    ({ theme }) => ({
        fontSize: 12,
        fontWeight: 400,
        whiteSpace: "nowrap",
        fontFamily: "inter",
    })
);

export default function MapDialog(props) {
    const { onClose, value: { city, cdn } } = props;
    const [regex, setRegex] = useState(null);

    useEffect(() => {
        const fetchRegex = () => {
            fetch("https://raw.githubusercontent.com/ruh010/locedge-db/master/regex.json")
                .then((data) => data.json())
                .then((resp) => setRegex(resp))
        }
        fetchRegex();
    }, []);

    return (
        <Dialog
            onClose={onClose}
            open={true}
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "2.4rem",
                    width: "64vw",
                },
            }}
        >
            <DialogTitle sx={{
                fontFamily: "Inter",
                fontSize: "2rem",
                textTransform: "capitalize",
                paddingBottom: 0,
                fontWeight: 700,
            }}>
                CDNs in <span style={{ color: "purple" }}>{city}</span>
            </DialogTitle>
            <TableContainer>
                {regex ? (
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <ListTableHeader>CDN</ListTableHeader>
                                <ListTableHeader>Header</ListTableHeader>
                                <ListTableHeader>GeoHint</ListTableHeader>
                                <ListTableHeader>Regex</ListTableHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cdn.map(({ name, code }) => (
                                <TableRow key={name}>
                                    <ListTableBody>{name}</ListTableBody>
                                    <ListTableBody>{regex[name] ? regex[name].header : "-"}</ListTableBody>
                                    <ListTableBody sx={{ whiteSpace: "normal" }}>{code.join(", ")}</ListTableBody>
                                    <ListTableBody>{regex[name] ? regex[name].regex : "-"}</ListTableBody>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <Backdrop open={true}>
                        <CircularProgress color="secondary" />
                    </Backdrop>
                )}
            </TableContainer>
        </Dialog>
    );
};